const RankTitle = () => {
  return (
    <span className="pl-[5%] text-Subhead">이 전시회 가고 싶으신가요?</span>
  );
};

export default RankTitle;
